var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSplitEx(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1335",
    d: "M942 48.611h-12v-12h12zm-10-2h8v-8h-8z",
    transform: "translate(-925 -31.611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1336",
    d: "M942 62.611h-12v-12h12zm-10-2h8v-8h-8z",
    transform: "translate(-925 -31.611)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1337",
    d: "M956 48.611h-12v-12h12zm-10-2h8v-8h-8z",
    transform: "translate(-925 -31.611)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1338",
    d: "M956 62.611h-12v-12h12zm-10-2h8v-8h-8z",
    transform: "translate(-925 -31.611)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplitEx);
export default __webpack_public_path__ + "static/media/icon-split-ex.55046497317ab0353b8fda21acb60536.svg";
export { ForwardRef as ReactComponent };